import React from 'react';
import PropTypes from 'prop-types';
import dayjs from 'dayjs';

import { ModuleDispatcher } from '$partials/modules';
import { Image } from '$partials/media';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @param {PropTypes.InferProps<typeof propTypes>} props
 */

// Event page - modal
const EventDetailPage = ({page}) => {

    return (
        <div className='overflow-hidden rounded-md'>
            <main
                className='bg-white min-h-screen relative modal-container-padding-right'
                id='main-content'>
                <div className='max-w-container bg-white mb-20 sm:pb-40 md:pb-60'>
                    <div className='flex flex-wrap max-w-container'>
                        {/* Left Sidebar */}
                        <div className='w-sidebar'>
                        </div>

                        {/* Main content */}
                        <div className='flex-1 flex flex-wrap self-start layout-negative-margin'>
                            {/* First section */}
                            <section className='w-full'>
                                <div className='layout-container-padding-right md:-mr-125'>
                                    <div className='mb-10 md:mb-0 layout-item-padding'>
                                        {/* Title */}
                                        <h1 className='type-style-3 mb-10 md:mb-40'>
                                            {page?.title}
                                        </h1>
                                        <div className='flex gap-70 md:gap-100'>
                                            <div className='w-50'>
                                                <p>Location</p>
                                                <h3 className='type-style-5'>
                                                    {page?.eventLocation}
                                                </h3>
                                            </div>
                                            <div className='w-50'>
                                                <p>Date</p>
                                                <h3 className='type-style-5'>
                                                    {dayjs(page?.eventDate).format('DD.MM.YY ha')}
                                                </h3>
                                            </div>
                                        </div>
                                        {/* Funds */}
                                        {page?.funds?.edges?.length > 0 &&
                                            page?.funds?.edges.map(({node: fund}, i) => {
                                                return (
                                                    <div
                                                        className={`block md:inline-block md:w-6/12 ${i % 2 === 0 ? 'layout-item-padding-right' : 'md:pl-18'} mt-20`}
                                                        key={i}>
                                                        <a
                                                            className={`type-style-8 ${fund?.branding?.toLowerCase()}-border background-6px pl-20`}
                                                            href={fund.url}
                                                            target='_self'>
                                                            {fund?.title}
                                                        </a>
                                                    </div>
                                                );
                                            })
                                        }
                                    </div>
                                </div>

                                {/* spacer */}
                                <div className='sm:w-1/12 md:w-2/12'/>

                                <div className='sm:layout-item-padding -ml-55 -mr-10 sm:mr-0 sm:ml-10'>
                                    <div className='overflow-hidden'>
                                        {page?.listingImage &&
                                        <Image
                                            containerClassName='sm:rounded-lg mt-30 md:mt-20'
                                            {...page.listingImage} />
                                        }
                                    </div>
                                </div>

                                {page?.imageCaption && (
                                    <div className='pt-15'>
                                        <figcaption className='layout-item-padding md:w-11/12 type-style-7'>
                                            {page?.imageCaption}
                                        </figcaption>
                                    </div>
                                )}
                            </section>
                        </div>
                    </div>

                    {/* Module dispatcher */}
                    {page.eventModules?.length > 0 &&
                        <section>
                            {page.eventModules?.map((module, i, { length, ...modules }) => {
                                const isLast = length - 1 === i;
                                const nextModuleType = modules[i + 1]?.__typename;
                                const previousModuleType = modules[i - 1]?.__typename;
                                return (
                                    <ModuleDispatcher
                                        {...module}
                                        isInModal={true}
                                        isLast={isLast}
                                        key={i + module?.id}
                                        nextModuleType={nextModuleType}
                                        pageTypename={page?.__typename}
                                        previousModuleType={previousModuleType}/>
                                );
                            })}
                        </section>
                    }
                </div>
            </main>

        </div>
    );
};

/* ========================================================================= */
/* Typing and exports */
/* ========================================================================= */

const propTypes = {
    page: PropTypes.shape({
        __typename: PropTypes.string,
        listingText: PropTypes.string,
        eventDate: PropTypes.string,
        eventLocation: PropTypes.string,
        eventModules: PropTypes.arrayOf(PropTypes.shape({})),
        searchDescription: PropTypes.string,
        listingImage: PropTypes.object,
        imageCaption: PropTypes.string,
        title: PropTypes.string,
        funds: PropTypes.shape({
            edges: PropTypes.arrayOf(PropTypes.shape({
                node: PropTypes.shape({
                    url: PropTypes.string,
                    title: PropTypes.string,
                    branding: PropTypes.string,
                }),
            }),),
        }),
    })
};

EventDetailPage.propTypes = propTypes;

export default EventDetailPage;
